import React from "react";
import { Text, StyleSheet, View, TouchableOpacity } from "react-native";

import cardStyles from "./cardStyles";
import AppTheme from "../../AppTheme";
import ElementItem from "../../elements/list/ElementItem";
import ManaHourMinutes from "../../common/ManaHourMinutes";
import ArrowAscending from "../../common/icons/ArrowAscending";
import { hasItems, sortBy, navigate } from "../../../../helpers/utils";
import MoodsHelper from "../../common/mood/MoodsHelper";
import { maxBy } from "lodash";
import appPages from "../../../../appPages";
import ElementsHelper from "../../elements/ElementsHelper";
import StatsCardChartProgress from "./StatsCardChartProgress";
import HourGlassIcon from "../../common/icons/HourGlassIcon";

export default function StatsCardChart({
  controller,
  elementsList,
  selectedDate,
  timeUnit,
  isNegative = false,
  hasPositive = true,
  changePage = null,
  showPercentage = false,
  showJournalDialog = () => {},
  togglePercentageView = () => {},
}) {
  if (!hasItems(elementsList)) return null;

  const lMaxElement = maxBy(elementsList, (el) => Math.abs(1 * el.progress));
  const lMax = Math.abs(1 * lMaxElement?.progress) || 0;

  elementsList.forEach((e) => (e.progress = 1 * e.progress));

  const elements = sortBy(
    elementsList,
    "progress",
    isNegative ? "asc" : "desc",
  );

  const headerText = isNegative
    ? hasPositive
      ? "...and less time on"
      : "You spent less time on"
    : "You spent more time on";

  // ------------------------------------- INIT -------------------------------------


  // ------------------------------------- METHODS -------------------------------------


  const findById = (reflection, targetId) => {
    if (reflection.item_id == targetId) {
      return reflection;
    } else {
      if (reflection.children) {
        for (let i in reflection.children) {
          const it = findById(reflection.children[i], targetId);
          if (it != null) return it;
        }
      }
      return null;
    }
  };

  const goToEditPage = (element, selectedDay) => {
    const reflection_data =
      controller.state.reflection_insights || controller.state.reflection;
    if (reflection_data) {
      const reflection = findById(reflection_data, element.id);

      const edit_day = selectedDay || selectedDate;
      //const day = header.days ? header.days[0] : null;
      const gem = reflection?.timeline?.gems
        ? reflection.timeline.gems.filter(
            (g) => g.day && g.day.startsWith(edit_day),
          )
        : null;

      let model = {
        timeline: reflection.timeline,
        children: reflection.children,
        goal: reflection.goal,
        edit_time_unit: timeUnit,
        edit_object: reflection.item_type || "time",
        edit_element_id: reflection.item_id,
        edit_day: edit_day,
        edit_icon: reflection.icon,
        edit_name: reflection.name,
        edit_notes: gem?.gem?.text || "",
        edit_gem_mood: gem?.gem?.mood || "",
        target_hours: gem?.hours || "",
        edit_id: gem?.gem?.gem_id || "",
        element: ElementsHelper.findById(controller, reflection.item_id),
      };

      const args = {
        reflection: { ...model },
        routineHours: null,
      };

      if (changePage) {
        changePage(appPages.reflectionDetailPage, {
          args,
          selectedPage: "rn:sets_reflection_detail",
        });
      } else {
        navigate(controller, "rn:sets_reflection_detail", "changepage", args);
      }
    }
  };

  return (
    <>
      <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
        <View style={styles.header}>
          <ArrowAscending
            style={isNegative ? { transform: [{ rotate: "180deg" }] } : {}}
          />

          <View style={[cardStyles.headerInfo, { marginLeft: 6, flex: 1 }]}>
            <Text style={cardStyles.title}>{headerText}</Text>
          </View>

          {!isNegative || !hasPositive ? (
            <HourGlassIcon
              style={styles.hourGlassIcon}
              color={AppTheme.DEFAULT_COLOR}
              onPress={togglePercentageView}
            />
          ) : null}
        </View>
      </View>

      <View style={styles.content}>
        {elements.map((elem, index) => (
          <View key={index} style={[styles.tableRow]}>
            {/* Element */}
            <ElementItem
              item={elem}
              controller={controller}
              noIcons={true}
              hideActions={true}
              showAssociations={"none"}
              onElementSelected={(element) =>
                goToEditPage(element, selectedDate)
              }
              style={{
                width: 200,
                paddingLeft: 0,
                marginRight: 4,
              }}
            />

            {/* Bar */}
            <StatsCardChartProgress
              data={elem}
              maxValue={lMax}
              showPercentage={showPercentage}
            />

            {/* Hours */}
            <TouchableOpacity
              onPress={() => showJournalDialog(elem)}
              style={[
                styles.iconContainer,
                elem.gem?.mood
                  ? {
                      ...MoodsHelper.geReflectionGemStyle(elem.gem.mood, false),
                    }
                  : {},
              ]}
            >
              <ManaHourMinutes duration={Math.abs(elem.totalHours)} />
            </TouchableOpacity>
          </View>
        ))}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 40,
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  hourGlassIcon: {
    width: 20,
    height: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginRight: 7,
  },
  iconContainer: {
    width: 32,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 4,
  },
});
